import { GET_EMPLOYEE_BY_STRUCT_ID } from "../../../enums/Request/leader.requests.types";

export const getEmployeesByStructIdAction = (listOfEmployee) => {
    return {
        type: GET_EMPLOYEE_BY_STRUCT_ID,
        payload: listOfEmployee,
    };
};